// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:  {
    databaseURL: 'https://mil-source.firebaseio.com',
    apiKey: "AIzaSyCnWA9z2Mm7SojzKKM6CEkOatkdrImqmnM",
    authDomain: "mil-source.firebaseapp.com",
    projectId: "mil-source",
    storageBucket: "mil-source.appspot.com",
    messagingSenderId: "810222696912",
    appId: "1:810222696912:web:0b1894189009add31321d5",
    measurementId: "G-NBC5YM2KH2"
  },
  indeed: {
    ApplicationName:	"mil source",
    ApplicationWebsite:	"https://mil-source.web.app/",
    CredentialType:	"OAuth2",
    ClientId:	"b7e68f518dea259cec5d1f00ebbfd6003e041ca7eaa8ca3bb322bb5599b431ad",
    ClientSecret:	"s0LKHh4srnXOMYC6SEjBufZ9f4gdfcLePB2bVCUD8cbibX9oqXbeaLtJxOVyUoZy"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
